module.exports = __webpack_public_path__ + "img/icon_13.6f0c72a4.png";